import type {
  Configurator,
  ConfiguratorResponse,
  LoginResponse,
  SystemGroup,
  SystemQuoteSpecs,
  SystemQuote,
  Customer,
  Address,
  BasketItem,
  OrderDetails,
  SaveQuoteResponse,
  ExceleraAddressResponse, BasketResponse, LogoutResponse, CustomerResponse
} from '@/types';
import { apiClient } from '@/lib/apiClient';

export async function getSystemGroups(): Promise<SystemGroup[]> {
  const { groups } = await apiClient(`/groups`);
  if(groups) {
    return groups;
  }
  return [];
}

export function fetchSystemGroupById(systemGroupId: string) {
  return apiClient(`/groups/${systemGroupId}`);
}

export function fetchSystemGroupRangesById(rangeId: string) {
  return apiClient(`/ranges/${rangeId}`);
}

export async function getSystemConfiguratorBySystemId(systemId: string): Promise<Configurator> {
  const { configurator }: ConfiguratorResponse = await apiClient(`/configurator/${systemId}`);
  return configurator;
}

export async function doLogin(email: string, passwd: string): Promise<boolean> {
  const { loginSuccess }: LoginResponse = await apiClient(`/account/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email, passwd })
  });
  return loginSuccess || false;
}

export async function saveQuote(systemQuote: SystemQuoteSpecs): Promise<SaveQuoteResponse> {
  return apiClient(`/account/save-quote`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      systemQuote
    })
  });
}

export async function getSavedQuotes(cookies: string = ''): Promise<SystemQuote[]> {
  return apiClient(`/account/saved-quotes`, {
    headers: {
      'Content-Type': 'application/json',
      Cookie: cookies
    }
  });
}

export async function getAccountOrders(cookies: string = ''): Promise<OrderDetails[]> {
  return apiClient(`/account/orders`, {
    headers: {
      'Content-Type': 'application/json',
      Cookie: cookies
    }
  });
}

export async function doLogout(): Promise<LogoutResponse> {
  return apiClient(`/account/logout`, {
    method: 'post'
  });
}

export async function fetchCustomerDetails() {
  return apiClient(`/account/details`);
}

export async function updateCustomerDetails(customer: Customer): Promise<CustomerResponse> {
  return apiClient(`/account/details`, {
    method: 'PUT',
    body: JSON.stringify(customer)
  });
}

export async function addCustomerAddress(address: Address): Promise<ExceleraAddressResponse> {
  return apiClient(`/account/details/address`, {
    method: 'POST',
    body: JSON.stringify(address)
  });
}

export async function updateCustomerAddress(address: Address): Promise<ExceleraAddressResponse> {
  return apiClient(`/account/details/address/${address._id}`, {
    method: 'PUT',
    body: JSON.stringify(address)
  });
}

export async function deleteCustomerAddress(address: Address | null): Promise<ExceleraAddressResponse> {
  return apiClient(`/account/details/address/${address._id}`, {
    method: 'DELETE',
  });
}

export function fetchBasket() {
  return apiClient('/basket');
}

export async function addItemToBasket(basketItem: SystemQuoteSpecs): Promise<BasketResponse> {
  const data = {
    basketItem,
    itemType: 'System Quote'
  };
  return apiClient('/basket', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function deleteItemInBasket(basketItem: BasketItem | null): Promise<BasketResponse> {
  return apiClient(`/basket/${basketItem._id}`, {
    method: 'DELETE'
  });
}

export async function updateItemInBasket(qty: number, basketItemId: string): Promise<BasketResponse> {
  const data = {
    qty,
  };
  return apiClient(`/basket/${basketItemId}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  });
}

export async function getOrderDetails(orderId: string): Promise<OrderDetails> {
  const { order } = await apiClient(`/account/orders/${orderId}`);
  return order;
}

export async function clearItemsInBasket(): Promise<BasketResponse> {
  return await apiClient('/basket/clear', {
    method: 'PUT'
  })
}
